import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum ConfigitBackend {
    model = 'model',
    ace = 'ace',
}

export interface ChangeParamEvent {
    backend?: ConfigitBackend;
    lang?: string;
    model?: string;
    application?: string;
    displayMode?: string;
}

@Injectable({
    providedIn: 'root',
})
export class EventService {
    constructor() {}

    private emitEvent = new Subject<ChangeParamEvent>();

    changeEmitted = this.emitEvent.asObservable();

    emitParamChange(params: ChangeParamEvent) {
        this.emitEvent.next(params);
    }
}
